import React, { Component } from "react";
import LoadingPanel from "../common/LoadingPanel";
import TovarFoto from "../common/TovarFoto";
import DialogWindow from "../common/DialogWindow";
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import { Localization } from "../common/Localization";
import confirmService from "../common/confirmService";
import { MessageTypeEnum, ButtonGroupEnum, ButtonMessageEnum } from "../../enums";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { kartyTagyController } from "../../controllers/kartytagy.controller";
import ZoznamTagov from "./KartyTagy/ZoznamTagov";
import ZoznamTagArtikle from "./KartyTagy/ZoznamTagArtikle";

class KartyTagyDialogContent extends Component {
    state = {
        selectedTags: [],
        loading: true,
        selectedArtikelId: null,
        selectedTag: null,
        errorMessage: null,
        artikleGridFilter: "",
        artikleGridFilterActive: false,
        cisloKarty: null
    };

    componentDidMount() {
        kartyTagyController.copyTableKartyTagyFromSqlCloud().then(async (response) => {
            if (response.errorMessage) {
                await confirmService.show({
                    type: response.messageType,
                    message: response.errorMessage,
                    logMessage: true
                });
            }
            this.setState({
                loading: false
            });
        });
    }

    changeSelectedTag = (selectedTag) => {
        this.setState({
            selectedTag: selectedTag
        });
    };

    changeSelectedTags = (selectedTags) => {
        this.setState({
            selectedTags: selectedTags
        });
    };

    changeSelectedArtikelId = (selectedArtikelId) => {
        this.setState({
            selectedArtikelId: selectedArtikelId
        });
    };

    handleErrorMessage = (errorMessage) => {
        this.setState({
            errorMessage: errorMessage
        });
    };

    handleFiltrFocus = () => {
        this.props.switchKeyboardEventHandler(true);
    };

    handleFiltrBlur = () => {
        this.props.switchKeyboardEventHandler(false);
    };

    handleFiltrChange = (e) => {
        this.setState({
            artikleGridFilter: e.value
        });
    };

    handleFiltrKeyPress = (e) => {
        if (e.key == "Enter") {
            this.handleFiltrClick();
        }
    };

    handleFiltrClick = () => {
        if (this.state.artikleGridFilterActive || this.state.artikleGridFilter == "") {
            // filtr byl aktivní, tak vypnout
            this.setState({
                cisloKarty: null,
                artikleGridFilter: "",
                artikleGridFilterActive: false
            });
        } else {
            // filtr nebyl aktivní, tak zapnout
            this.setState({
                cisloKarty: this.state.artikleGridFilter,
                artikleGridFilterActive: true
            });
        }
    };

    render() {
        var localizationService = provideLocalizationService(this);
        let contents = this.state.loading ? (
            <LoadingPanel />
        ) : (
            <React.Fragment>
                <div id="KartyTagyDialogContent">
                    <div>
                        <div className="col-lg-5">
                            <ZoznamTagov
                                changeSelectedTag={this.changeSelectedTag}
                                changeSelectedTags={this.changeSelectedTags}
                                multiselect={true}
                                handleErrorMessage={this.handleErrorMessage}
                                cisloKarty={this.state.cisloKarty}
                            />
                        </div>

                        <div className="col-lg-4">
                            <ZoznamTagArtikle
                                selectedTag={this.state.selectedTag}
                                changeSelectedArtikelId={this.changeSelectedArtikelId}
                                cisloKarty={this.state.cisloKarty}
                            />
                        </div>

                        <div className="col-lg-3">
                            <TovarFoto idKarta={this.state.selectedArtikelId} />
                        </div>
                    </div>
                    <div>
                        <div className="col-lg-5">
                            <div className="col-xs-7">
                                <label className="m-r-sm">{localizationService.toLanguageString("KartyTagy.Filtr artiklov", "Filtr artiklov")}</label>
                                <Input
                                    className="m-r-sm"
                                    value={this.state.artikleGridFilter}
                                    placeholder="Zadejte filtr..."
                                    onFocus={this.handleFiltrFocus}
                                    onBlur={this.handleFiltrBlur}
                                    onChange={this.handleFiltrChange}
                                    onKeyPress={this.handleFiltrKeyPress}
                                />
                                <Button
                                    icon={this.state.artikleGridFilterActive ? "filter-clear" : "filter"}
                                    title="Filtrovat"
                                    disabled={this.state.artikleGridFilter == ""}
                                    onClick={this.handleFiltrClick}
                                />
                            </div>
                            <div className="col-xs-5 text-right">{this.state.footerPocetPrijatych}</div>
                        </div>
                        <div className="col-lg-4"></div>
                        <div className="col-lg-3"></div>
                    </div>
                </div>
                <DialogWindow dialog={this.state.dialog} />
            </React.Fragment>
        );
        contents = this.state.errorMessage == null ? contents : <div className="alert alert-danger">{this.state.errorMessage}</div>;
        return <div>{contents}</div>;
    }
}

export default KartyTagyDialogContent;



// WEBPACK FOOTER //
// ./src/components/dialogs/KartyTagyDialogContent.js